module.exports = __webpack_public_path__ + "img/596.a3f1371f.jpg";